import { ProfileState } from '../store/profile';
import { useAppSelector } from './store';

export const useProfileData = () => {
  return useAppSelector<ProfileState>((state) => state.profile);
};
